// extracted by mini-css-extract-plugin
export default {"table":"YThsYhdJXpqDFfsQ353D"};